import * as jotai from 'jotai'

import * as api from '@owl-nest/api-client/next'
import * as hooks from '@owl-nest/hooks'

import * as base from './base'

export const SHARED_PROJECT_CACHE = jotai.atom<hooks.Cache<api.Project<any>>>({})

export function useProjectSharedQuery<EXTRA_FIELDS extends string>(
  config: base.LoadConfig<EXTRA_FIELDS>,
): hooks.SharedQueryHelper<api.Project<EXTRA_FIELDS>, [slugOrId: string | number]> {
  const sharedQuery = hooks.useSharedQuery((slugOrId: string | number) => base.load(slugOrId, config), {
    atom: SHARED_PROJECT_CACHE,
    id,
  })

  return sharedQuery
}

// FIXME: id function should also include extrafields.
export function id(slugOrId: string | number): string {
  return String([slugOrId])
}
